import React from "react";
import Lottie from "lottie-react";
import loadingFilesAnimation from "../assets/animations/loading-files.json";

const LayoutSkeleton = ({ message }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 relative">
      {/* Logo - absolute top left */}
      <img
        src="/Logo_EzSignly.png"
        alt="EzSignly"
        className="absolute top-4 left-4 h-10 w-auto"
      />
      {/* Animation - centered */}
      <div className="w-80 h-20 sm:w-96 sm:h-24">
        <Lottie
          animationData={loadingFilesAnimation}
          loop
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      {message && (
        <p className="mt-4 text-sm text-gray-500 text-center">{message}</p>
      )}
    </div>
  );
};

export default LayoutSkeleton;
